import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckIcon, ShieldCheckIcon, ChevronDownIcon, StarIcon, LockIcon, ZapIcon, FileTextIcon, BrainIcon, BookOpenIcon, PlayIcon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
import { SocialProofPopup } from './SocialProofPopup';
import { PricingGrid } from './PricingGrid';
const IMAGES = {
  MAIN: 'https://cdn.magicpatterns.com/uploads/rkmU6qCqur8ByocWsgGsBq/MAESTRO_CERRAJERO.png'
};
const LINKS = {
  PACK_COMPLETO: 'https://mi-tienda-pro-8012.myshopify.com/cart/48504331469019:1',
  PACK_PREMIUM: 'https://mi-tienda-pro-8012.myshopify.com/cart/48504331895003:1'
};
export function SalesPage() {
  const [openModule, setOpenModule] = useState<number | null>(null);
  const [selectedPack, setSelectedPack] = useState(1); // Default to premium
  const packLinks = [LINKS.PACK_COMPLETO, LINKS.PACK_PREMIUM];
  const [urgencyTime, setUrgencyTime] = useState({
    hours: 2,
    minutes: 13,
    seconds: 30
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setUrgencyTime(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        seconds--;
        if (seconds < 0) {
          seconds = 59;
          minutes--;
        }
        if (minutes < 0) {
          minutes = 59;
          hours--;
        }
        if (hours < 0) {
          hours = 0;
          minutes = 0;
          seconds = 0;
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const scrollToPricing = () => {
    const element = document.getElementById('pricing');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="font-sans text-gray-300 bg-[#0a0e27] min-h-screen flex flex-col selection:bg-[#16a34a] selection:text-black" data-id="element-43">
      <CountdownTimer data-id="element-44" />
      <SocialProofPopup data-id="element-45" />

      {/* 1. HERO SECTION */}
      <section className="py-4 md:py-6 px-3 md:px-4 text-center bg-gradient-to-b from-[#0a0e27] via-[#0c1333] to-[#0f172a]" data-id="element-46">
        <div className="max-w-3xl mx-auto flex flex-col items-center" data-id="element-47">
          <p className="text-[#16a34a] text-[10px] md:text-xs font-black uppercase tracking-widest mb-2 drop-shadow-[0_0_8px_rgba(22,163,74,0.5)]" data-id="element-48">
            ⭐ EL RECURSO #1 PARA GENERAR INGRESOS CON CERRAJERÍA ⭐
          </p>

          <h1 className="text-xl md:text-3xl lg:text-4xl font-black text-white mb-1 leading-tight uppercase drop-shadow-lg" data-id="element-49">
            Aprendé una habilidad real y empezá a ganar dinero abriendo puertas,
            cambiando cerraduras y resolviendo urgencias
          </h1>

          <p className="text-[#16a34a] text-sm md:text-lg font-black italic mb-3 uppercase drop-shadow-[0_0_8px_rgba(22,163,74,0.4)]" data-id="element-50">
            aunque no tengas experiencia
          </p>

          <div onClick={scrollToPricing} className="cursor-pointer hover:scale-[1.02] transition-transform duration-300 my-2 w-full max-w-lg relative group" data-id="element-51">
            <div className="absolute inset-0 bg-[#16a34a] opacity-20 blur-2xl rounded-full group-hover:opacity-30 transition-opacity" data-id="element-52"></div>
            <img src={IMAGES.MAIN} alt="Mega Pack Maestro Cerrajero" className="w-full relative z-10 drop-shadow-[0_0_25px_rgba(22,163,74,0.3)]" data-id="element-53" />
          </div>

          <p className="text-xs md:text-sm text-[#4ade80] font-black italic mb-1.5 uppercase tracking-wider drop-shadow-sm" data-id="element-54">
            TODO EN UN SOLO LUGAR. LISTO PARA USAR. SIN CONOCIMIENTOS PREVIOS.
          </p>

          <p className="text-[11px] md:text-xs text-gray-400 mb-3 max-w-xl mx-auto font-bold leading-snug" data-id="element-55">
            El sistema que están utilizando personas comunes para aprender
            cerrajería desde cero y comenzar a trabajar en pocas semanas
          </p>

          <div className="flex justify-center gap-2 md:gap-4 text-[9px] md:text-[10px] text-gray-400 font-black flex-nowrap uppercase tracking-widest mb-3" data-id="element-56">
            <span className="flex items-center gap-1 whitespace-nowrap" data-id="element-57">
              <FileTextIcon className="w-3 h-3 text-[#16a34a]" data-id="element-58" /> 100% PDF +
              Videos
            </span>
            <span className="flex items-center gap-1 whitespace-nowrap" data-id="element-59">
              <ZapIcon className="w-3 h-3 text-[#16a34a]" data-id="element-60" /> Acceso inmediato
            </span>
            <span className="flex items-center gap-1 whitespace-nowrap" data-id="element-61">
              <LockIcon className="w-3 h-3 text-[#16a34a]" data-id="element-62" /> Mercado Pago
            </span>
          </div>

          <button onClick={scrollToPricing} className="cta-pulse w-full max-w-md bg-[#16a34a] hover:bg-[#15803d] text-black font-black text-sm md:text-lg py-3 px-6 rounded-xl transition-all duration-200 mb-2 uppercase tracking-wide shadow-[0_0_20px_rgba(22,163,74,0.4)]" data-id="element-63">
            → QUIERO ACCEDER AHORA
          </button>

          <div className="flex justify-center gap-2 md:gap-4 text-[9px] md:text-[10px] text-gray-400 font-black flex-nowrap uppercase tracking-widest" data-id="element-64">
            <span className="flex items-center gap-1 whitespace-nowrap" data-id="element-65">
              <ShieldCheckIcon className="w-3 h-3 text-[#16a34a]" data-id="element-66" /> Garantía 7
              días
            </span>
            <span className="flex items-center gap-1 whitespace-nowrap" data-id="element-67">
              <LockIcon className="w-3 h-3 text-[#16a34a]" data-id="element-68" /> Pago seguro
            </span>
            <span className="flex items-center gap-1 whitespace-nowrap" data-id="element-69">
              <ZapIcon className="w-3 h-3 text-[#16a34a]" data-id="element-70" /> Acceso inmediato
            </span>
          </div>
        </div>
      </section>

      {/* 2. PAIN POINTS */}
      <section className="py-3 px-4 bg-[#0f172a]" data-id="element-71">
        <div className="max-w-2xl mx-auto bg-[#0d1530]/90 backdrop-blur-sm p-4 rounded-xl border-2 border-emerald-500/40 shadow-[0_0_15px_rgba(22,163,74,0.2)]" data-id="element-72">
          <h2 className="text-lg md:text-xl font-black text-center text-red-500 mb-3 uppercase drop-shadow-[0_0_10px_rgba(239,68,68,0.3)]" data-id="element-73">
            ❌ ¿TE PASA ESTO?
          </h2>
          <div className="space-y-1.5 text-xs md:text-sm text-gray-200 font-bold leading-snug" data-id="element-74">
            <p className="flex items-start gap-2" data-id="element-75">
              <span className="flex-shrink-0 drop-shadow-[0_0_5px_rgba(239,68,68,0.5)]" data-id="element-76">
                ❌
              </span>{' '}
              Querés generar ingresos pero no sabés por dónde empezar
            </p>
            <p className="flex items-start gap-2" data-id="element-77">
              <span className="flex-shrink-0 drop-shadow-[0_0_5px_rgba(239,68,68,0.5)]" data-id="element-78">
                ❌
              </span>{' '}
              No te alcanza el dinero y necesitás una solución urgente
            </p>
            <p className="flex items-start gap-2" data-id="element-79">
              <span className="flex-shrink-0 drop-shadow-[0_0_5px_rgba(239,68,68,0.5)]" data-id="element-80">
                ❌
              </span>{' '}
              Dependés de un trabajo que no te permite crecer
            </p>
            <p className="flex items-start gap-2" data-id="element-81">
              <span className="flex-shrink-0 drop-shadow-[0_0_5px_rgba(239,68,68,0.5)]" data-id="element-82">
                ❌
              </span>{' '}
              No tenés una habilidad concreta para ofrecer
            </p>
            <p className="flex items-start gap-2" data-id="element-83">
              <span className="flex-shrink-0 drop-shadow-[0_0_5px_rgba(239,68,68,0.5)]" data-id="element-84">
                ❌
              </span>{' '}
              Sentís que el tiempo pasa y seguís en el mismo lugar
            </p>
          </div>
        </div>
      </section>

      {/* 3. REALITY SECTION */}
      <section className="py-3 px-4 bg-[#111827]" data-id="element-85">
        <div className="max-w-2xl mx-auto bg-[#0d1530]/90 backdrop-blur-sm p-4 rounded-xl border-2 border-emerald-500/40 shadow-[0_0_15px_rgba(22,163,74,0.2)]" data-id="element-86">
          <h2 className="text-lg md:text-xl font-black text-center text-white mb-2 uppercase drop-shadow-md" data-id="element-87">
            💥 LA REALIDAD
          </h2>
          <p className="text-xs md:text-sm text-gray-300 font-bold mb-2 text-center" data-id="element-88">
            Hoy hay personas que están generando ingresos con trabajos simples
            como:
          </p>
          <div className="space-y-1.5 text-xs md:text-sm text-white font-black mb-2 ml-2 md:ml-8" data-id="element-89">
            <p className="flex items-center gap-2" data-id="element-90">
              <span className="text-[#16a34a]" data-id="element-91">👉</span> Apertura de puertas
              trabadas
            </p>
            <p className="flex items-center gap-2" data-id="element-92">
              <span className="text-[#16a34a]" data-id="element-93">👉</span> Cambio de cerraduras
            </p>
            <p className="flex items-center gap-2" data-id="element-94">
              <span className="text-[#16a34a]" data-id="element-95">👉</span> Resolución de urgencias
              básicas
            </p>
          </div>
          <p className="text-xs md:text-sm text-[#4ade80] font-black text-center uppercase tracking-wider" data-id="element-96">
            Y lo hacen con herramientas accesibles y conocimiento práctico.
          </p>
        </div>
      </section>

      {/* 4. WARNING SECTION */}
      <section className="py-3 px-4 bg-[#0f172a]" data-id="element-97">
        <div className="max-w-2xl mx-auto bg-[#0d1530]/90 backdrop-blur-sm p-4 rounded-xl border-2 border-emerald-500/40 shadow-[0_0_15px_rgba(22,163,74,0.2)]" data-id="element-98">
          <h2 className="text-lg md:text-xl font-black text-center text-[#f59e0b] mb-2 uppercase drop-shadow-[0_0_10px_rgba(245,158,11,0.3)]" data-id="element-99">
            ⚠️ VOS TAMBIÉN PODÉS HACERLO
          </h2>
          <p className="text-xs md:text-sm text-gray-300 font-bold mb-2 text-center" data-id="element-100">
            Pero no lo estás haciendo porque:
          </p>
          <div className="space-y-1.5 text-xs md:text-sm text-white font-black ml-2 md:ml-8" data-id="element-101">
            <p className="flex items-center gap-2" data-id="element-102">
              <span className="text-red-500" data-id="element-103">👉</span> No sabés por dónde
              empezar
            </p>
            <p className="flex items-center gap-2" data-id="element-104">
              <span className="text-red-500" data-id="element-105">👉</span> No tenés una guía clara
            </p>
            <p className="flex items-center gap-2" data-id="element-106">
              <span className="text-red-500" data-id="element-107">👉</span> Todo lo que encontrás
              está desordenado
            </p>
          </div>
        </div>
      </section>

      {/* 5. EXTRA CTA */}
      <section className="py-4 px-4 text-center bg-[#0a0e27]" data-id="element-108">
        <button onClick={scrollToPricing} className="cta-pulse w-full max-w-2xl bg-[#16a34a] hover:bg-[#15803d] text-black font-black text-xs md:text-base py-3 px-4 rounded-xl transition-all duration-200 uppercase tracking-wide shadow-[0_0_20px_rgba(22,163,74,0.4)]" data-id="element-109">
          🔥 ¡QUIERO DEJAR DE PERDER TIEMPO Y EMPEZAR A GENERAR INGRESOS!
        </button>
      </section>

      {/* 6. SOLUTION SECTION */}
      <section className="py-3 px-4 bg-[#0c1333]" data-id="element-110">
        <div className="max-w-2xl mx-auto bg-[#0d1530]/90 backdrop-blur-sm p-4 rounded-xl border-2 border-emerald-500/40 shadow-[0_0_15px_rgba(22,163,74,0.2)]" data-id="element-111">
          <h2 className="text-lg md:text-xl font-black text-center text-white mb-3 uppercase drop-shadow-md" data-id="element-112">
            <span className="underline decoration-[#16a34a] decoration-4 underline-offset-4" data-id="element-113">
              🚀 CON ESTE SISTEMA VAS A PODER:
            </span>
          </h2>
          <div className="space-y-1.5 text-xs md:text-sm text-white font-black leading-snug" data-id="element-114">
            <p className="flex items-start gap-2" data-id="element-115">
              <span className="flex-shrink-0 text-[#16a34a] drop-shadow-[0_0_5px_rgba(22,163,74,0.5)]" data-id="element-116">
                ✅
              </span>{' '}
              Aprender cerrajería desde cero, paso a paso
            </p>
            <p className="flex items-start gap-2" data-id="element-117">
              <span className="flex-shrink-0 text-[#16a34a] drop-shadow-[0_0_5px_rgba(22,163,74,0.5)]" data-id="element-118">
                ✅
              </span>{' '}
              Abrir puertas sin dañar las cerraduras
            </p>
            <p className="flex items-start gap-2" data-id="element-119">
              <span className="flex-shrink-0 text-[#16a34a] drop-shadow-[0_0_5px_rgba(22,163,74,0.5)]" data-id="element-120">
                ✅
              </span>{' '}
              Cambiar cerraduras completas
            </p>
            <p className="flex items-start gap-2" data-id="element-121">
              <span className="flex-shrink-0 text-[#16a34a] drop-shadow-[0_0_5px_rgba(22,163,74,0.5)]" data-id="element-122">
                ✅
              </span>{' '}
              Entender cómo funcionan los sistemas
            </p>
            <p className="flex items-start gap-2" data-id="element-123">
              <span className="flex-shrink-0 text-[#16a34a] drop-shadow-[0_0_5px_rgba(22,163,74,0.5)]" data-id="element-124">
                ✅
              </span>{' '}
              Ofrecer servicios pagos desde el inicio
            </p>
          </div>
        </div>
      </section>

      {/* 7. TIMELINE SECTION */}
      <section className="py-3 px-4 bg-[#0f172a]" data-id="element-125">
        <div className="max-w-2xl mx-auto bg-[#0d1530]/90 backdrop-blur-sm p-4 rounded-xl border-2 border-emerald-500/40 shadow-[0_0_15px_rgba(22,163,74,0.2)]" data-id="element-126">
          <h2 className="text-lg md:text-xl font-black text-center text-white mb-3 uppercase drop-shadow-md" data-id="element-127">
            ⏱ ¿EN CUÁNTO TIEMPO?
          </h2>
          <div className="space-y-2 text-xs md:text-sm text-gray-200 font-bold ml-2 md:ml-8" data-id="element-128">
            <p className="flex items-center gap-2" data-id="element-129">
              <span className="text-[#16a34a] text-lg" data-id="element-130">👉</span> En pocos días
              vas a entender cómo funciona todo
            </p>
            <p className="flex items-center gap-2" data-id="element-131">
              <span className="text-[#16a34a] text-lg" data-id="element-132">👉</span> En 1 a 2
              semanas podés comenzar a practicar
            </p>
            <p className="flex items-center gap-2" data-id="element-133">
              <span className="text-[#16a34a] text-lg" data-id="element-134">👉</span> En pocas
              semanas podés realizar tus primeros trabajos
            </p>
          </div>
        </div>
      </section>

      {/* 8. EARNINGS SECTION */}
      <section className="py-3 px-4 bg-[#111827]" data-id="element-135">
        <div className="max-w-2xl mx-auto bg-[#0d1530]/90 backdrop-blur-sm p-5 rounded-xl border-2 border-emerald-500/50 shadow-[0_0_20px_rgba(245,158,11,0.15)] text-center" data-id="element-136">
          <h2 className="text-xl md:text-2xl font-black text-[#f59e0b] mb-2 uppercase drop-shadow-[0_0_10px_rgba(245,158,11,0.3)]" data-id="element-137">
            💰 ¿CUÁNTO PODÉS GENERAR?
          </h2>
          <p className="text-xs md:text-sm text-white font-bold mb-1 uppercase tracking-wider" data-id="element-138">
            Un solo trabajo puede pagarse entre:
          </p>
          <div className="my-2" data-id="element-139">
            <p className="text-3xl md:text-4xl font-black text-[#f59e0b] drop-shadow-[0_0_15px_rgba(245,158,11,0.4)] leading-none" data-id="element-140">
              💵 $10.000 y $30.000
            </p>
            <p className="text-[10px] md:text-xs text-gray-400 font-bold uppercase tracking-widest mt-1" data-id="element-141">
              (apertura o cambio simple)
            </p>
          </div>
          <div className="mt-3 inline-block text-left bg-black/30 p-3 rounded-lg border border-emerald-500/30" data-id="element-142">
            <p className="flex items-center gap-2 text-xs md:text-sm text-white font-black mb-1" data-id="element-143">
              <span className="text-[#16a34a]" data-id="element-144">👉</span> Con 2 o 3 trabajos
              podés recuperar la inversión
            </p>
            <p className="flex items-center gap-2 text-xs md:text-sm text-[#4ade80] font-black" data-id="element-145">
              <span className="text-[#16a34a]" data-id="element-146">👉</span> Todo lo demás es
              ganancia
            </p>
          </div>
        </div>
      </section>

      {/* 9. PRODUCT PRESENTATION */}
      <section className="py-4 px-4 bg-[#0a0e27] text-center" data-id="element-147">
        <div className="max-w-3xl mx-auto bg-[#0d1530]/90 backdrop-blur-sm p-5 rounded-xl border-2 border-emerald-500/50 shadow-[0_0_20px_rgba(22,163,74,0.3)] relative overflow-hidden" data-id="element-148">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-[#16a34a] to-transparent" data-id="element-149"></div>
          <span className="inline-block bg-red-600 text-white text-[10px] md:text-xs font-black px-3 py-1 rounded-full mb-2 uppercase tracking-widest shadow-[0_0_10px_rgba(220,38,38,0.5)]" data-id="element-150">
            🔥 PRESENTAMOS:
          </span>
          <h2 className="text-2xl md:text-4xl font-black text-white mb-3 uppercase drop-shadow-lg leading-tight" data-id="element-151">
            💣 MEGA PACK MAESTRO CERRAJERO
          </h2>
          <p className="text-xs md:text-sm text-[#4ade80] font-black uppercase tracking-wider max-w-xl mx-auto leading-relaxed" data-id="element-152">
            Un sistema completo en PDF + videos, explicado de forma clara,
            simple y directa, diseñado para que cualquier persona pueda aprender
            desde cero.
          </p>
        </div>
      </section>

      {/* 10. CONTENTS SECTION */}
      <section className="py-3 px-4 bg-[#0c1333]" data-id="element-153">
        <div className="max-w-2xl mx-auto" data-id="element-154">
          <h2 className="text-xl md:text-2xl font-black text-center text-white mb-3 uppercase drop-shadow-md" data-id="element-155">
            📦 ¿QUÉ INCLUYE?
          </h2>

          <div className="space-y-1.5" data-id="element-156">
            {/* Module 1 */}
            <div className="bg-[#0d1530]/90 backdrop-blur-sm rounded-lg border-2 border-emerald-500/40 overflow-hidden shadow-[0_0_10px_rgba(22,163,74,0.15)]" data-id="element-157">
              <button onClick={() => setOpenModule(openModule === 0 ? null : 0)} className="w-full flex items-center gap-2 p-3 text-left cursor-pointer hover:bg-white/5 transition-colors" data-id="element-158">
                <LockIcon className="w-5 h-5 text-blue-400 flex-shrink-0" data-id="element-159" />
                <h3 className="text-xs md:text-sm font-black text-white flex-1 uppercase" data-id="element-160">
                  🔓 CERRAJERÍA DE PUERTAS (BASE COMPLETA)
                </h3>
                <ChevronDownIcon className={`w-4 h-4 text-[#16a34a] transition-transform ${openModule === 0 ? 'rotate-180' : ''}`} data-id="element-161" />
              </button>
              <AnimatePresence data-id="element-162">
                {openModule === 0 && <motion.div initial={{
                height: 0
              }} animate={{
                height: 'auto'
              }} exit={{
                height: 0
              }} className="overflow-hidden bg-black/20" data-id="element-163">
                    <ul className="p-3 border-t border-emerald-500/20 space-y-1 text-[10px] md:text-xs text-gray-300 font-bold" data-id="element-164">
                      <li className="flex gap-1.5" data-id="element-165">
                        <CheckIcon className="w-3.5 h-3.5 text-[#16a34a] flex-shrink-0" data-id="element-166" />{' '}
                        Funcionamiento de las cerraduras
                      </li>
                      <li className="flex gap-1.5" data-id="element-167">
                        <CheckIcon className="w-3.5 h-3.5 text-[#16a34a] flex-shrink-0" data-id="element-168" />{' '}
                        Tipos de cerraduras más comunes
                      </li>
                      <li className="flex gap-1.5" data-id="element-169">
                        <CheckIcon className="w-3.5 h-3.5 text-[#16a34a] flex-shrink-0" data-id="element-170" />{' '}
                        Técnicas de apertura sin daño
                      </li>
                      <li className="flex gap-1.5" data-id="element-171">
                        <CheckIcon className="w-3.5 h-3.5 text-[#16a34a] flex-shrink-0" data-id="element-172" />{' '}
                        Uso correcto de ganzúas
                      </li>
                      <li className="flex gap-1.5" data-id="element-173">
                        <CheckIcon className="w-3.5 h-3.5 text-[#16a34a] flex-shrink-0" data-id="element-174" />{' '}
                        Métodos reales utilizados en el trabajo
                      </li>
                      <li className="flex gap-1.5" data-id="element-175">
                        <CheckIcon className="w-3.5 h-3.5 text-[#16a34a] flex-shrink-0" data-id="element-176" />{' '}
                        Resolución de problemas frecuentes
                      </li>
                    </ul>
                  </motion.div>}
              </AnimatePresence>
            </div>

            {/* Module 2 */}
            <div className="bg-[#0d1530]/90 backdrop-blur-sm rounded-lg border-2 border-emerald-500/40 overflow-hidden shadow-[0_0_10px_rgba(22,163,74,0.15)]" data-id="element-177">
              <button onClick={() => setOpenModule(openModule === 1 ? null : 1)} className="w-full flex items-center gap-2 p-3 text-left cursor-pointer hover:bg-white/5 transition-colors" data-id="element-178">
                <BrainIcon className="w-5 h-5 text-green-400 flex-shrink-0" data-id="element-179" />
                <h3 className="text-xs md:text-sm font-black text-white flex-1 uppercase" data-id="element-180">
                  🧠 TÉCNICAS DE LOCKPICKING (GANZÚAS)
                </h3>
                <ChevronDownIcon className={`w-4 h-4 text-[#16a34a] transition-transform ${openModule === 1 ? 'rotate-180' : ''}`} data-id="element-181" />
              </button>
              <AnimatePresence data-id="element-182">
                {openModule === 1 && <motion.div initial={{
                height: 0
              }} animate={{
                height: 'auto'
              }} exit={{
                height: 0
              }} className="overflow-hidden bg-black/20" data-id="element-183">
                    <ul className="p-3 border-t border-emerald-500/20 space-y-1 text-[10px] md:text-xs text-gray-300 font-bold" data-id="element-184">
                      <li className="flex gap-1.5" data-id="element-185">
                        <CheckIcon className="w-3.5 h-3.5 text-[#16a34a] flex-shrink-0" data-id="element-186" />{' '}
                        Uso correcto de herramientas
                      </li>
                      <li className="flex gap-1.5" data-id="element-187">
                        <CheckIcon className="w-3.5 h-3.5 text-[#16a34a] flex-shrink-0" data-id="element-188" />{' '}
                        Técnicas básicas y avanzadas
                      </li>
                      <li className="flex gap-1.5" data-id="element-189">
                        <CheckIcon className="w-3.5 h-3.5 text-[#16a34a] flex-shrink-0" data-id="element-190" />{' '}
                        Práctica guiada
                      </li>
                      <li className="flex gap-1.5" data-id="element-191">
                        <CheckIcon className="w-3.5 h-3.5 text-[#16a34a] flex-shrink-0" data-id="element-192" />{' '}
                        Errores comunes y cómo evitarlos
                      </li>
                    </ul>
                  </motion.div>}
              </AnimatePresence>
            </div>

            {/* Module 3 */}
            <div className="bg-[#0d1530]/90 backdrop-blur-sm rounded-lg border-2 border-emerald-500/40 overflow-hidden shadow-[0_0_10px_rgba(22,163,74,0.15)]" data-id="element-193">
              <button onClick={() => setOpenModule(openModule === 2 ? null : 2)} className="w-full flex items-center gap-2 p-3 text-left cursor-pointer hover:bg-white/5 transition-colors" data-id="element-194">
                <BookOpenIcon className="w-5 h-5 text-amber-400 flex-shrink-0" data-id="element-195" />
                <h3 className="text-xs md:text-sm font-black text-white flex-1 uppercase" data-id="element-196">
                  📘 MANUALES PROFESIONALES (PDF)
                </h3>
                <ChevronDownIcon className={`w-4 h-4 text-[#16a34a] transition-transform ${openModule === 2 ? 'rotate-180' : ''}`} data-id="element-197" />
              </button>
              <AnimatePresence data-id="element-198">
                {openModule === 2 && <motion.div initial={{
                height: 0
              }} animate={{
                height: 'auto'
              }} exit={{
                height: 0
              }} className="overflow-hidden bg-black/20" data-id="element-199">
                    <ul className="p-3 border-t border-emerald-500/20 space-y-1 text-[10px] md:text-xs text-gray-300 font-bold" data-id="element-200">
                      <li className="flex gap-1.5" data-id="element-201">
                        <CheckIcon className="w-3.5 h-3.5 text-[#16a34a] flex-shrink-0" data-id="element-202" />{' '}
                        Información organizada y práctica
                      </li>
                      <li className="flex gap-1.5" data-id="element-203">
                        <CheckIcon className="w-3.5 h-3.5 text-[#16a34a] flex-shrink-0" data-id="element-204" />{' '}
                        Explicaciones claras
                      </li>
                      <li className="flex gap-1.5" data-id="element-205">
                        <CheckIcon className="w-3.5 h-3.5 text-[#16a34a] flex-shrink-0" data-id="element-206" />{' '}
                        Contenido directo, sin relleno
                      </li>
                    </ul>
                  </motion.div>}
              </AnimatePresence>
            </div>

            {/* Module 4 */}
            <div className="bg-[#0d1530]/90 backdrop-blur-sm rounded-lg border-2 border-emerald-500/40 overflow-hidden shadow-[0_0_10px_rgba(22,163,74,0.15)]" data-id="element-207">
              <button onClick={() => setOpenModule(openModule === 3 ? null : 3)} className="w-full flex items-center gap-2 p-3 text-left cursor-pointer hover:bg-white/5 transition-colors" data-id="element-208">
                <PlayIcon className="w-5 h-5 text-red-400 flex-shrink-0" data-id="element-209" />
                <h3 className="text-xs md:text-sm font-black text-white flex-1 uppercase" data-id="element-210">
                  🎥 VIDEOS PASO A PASO
                </h3>
                <ChevronDownIcon className={`w-4 h-4 text-[#16a34a] transition-transform ${openModule === 3 ? 'rotate-180' : ''}`} data-id="element-211" />
              </button>
              <AnimatePresence data-id="element-212">
                {openModule === 3 && <motion.div initial={{
                height: 0
              }} animate={{
                height: 'auto'
              }} exit={{
                height: 0
              }} className="overflow-hidden bg-black/20" data-id="element-213">
                    <ul className="p-3 border-t border-emerald-500/20 space-y-1 text-[10px] md:text-xs text-gray-300 font-bold" data-id="element-214">
                      <li className="flex gap-1.5" data-id="element-215">
                        <CheckIcon className="w-3.5 h-3.5 text-[#16a34a] flex-shrink-0" data-id="element-216" />{' '}
                        Explicaciones simples
                      </li>
                      <li className="flex gap-1.5" data-id="element-217">
                        <CheckIcon className="w-3.5 h-3.5 text-[#16a34a] flex-shrink-0" data-id="element-218" />{' '}
                        Aplicación real
                      </li>
                      <li className="flex gap-1.5" data-id="element-219">
                        <CheckIcon className="w-3.5 h-3.5 text-[#16a34a] flex-shrink-0" data-id="element-220" />{' '}
                        Aprendizaje visual
                      </li>
                    </ul>
                  </motion.div>}
              </AnimatePresence>
            </div>
          </div>
        </div>
      </section>

      {/* 11. BONUSES SECTION */}
      <section className="py-4 px-4 bg-[#0f172a]" data-id="element-221">
        <div className="max-w-3xl mx-auto" data-id="element-222">
          <div className="text-center mb-4" data-id="element-223">
            <h2 className="text-xl md:text-2xl font-black text-white mb-2 uppercase drop-shadow-md" data-id="element-224">
              🎁 ADEMÁS HOY TE LLEVÁS GRATIS:
            </h2>
            <span className="inline-block bg-red-600 text-white text-[10px] md:text-xs font-black px-4 py-1.5 rounded-lg shadow-[0_0_15px_rgba(220,38,38,0.5)] uppercase tracking-widest" data-id="element-225">
              ¡GRATIS POR EL DÍA DE HOY!
            </span>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-2 mb-3" data-id="element-226">
            <div className="bg-[#0d1530]/90 backdrop-blur-sm rounded-xl border-2 border-emerald-500/40 p-3 flex flex-col shadow-[0_0_15px_rgba(22,163,74,0.2)]" data-id="element-227">
              <h3 className="text-xs md:text-sm font-black text-[#f59e0b] mb-1.5 uppercase" data-id="element-228">
                🧰 Maletín Inteligente del Cerrajero
              </h3>
              <p className="text-[10px] md:text-xs text-gray-300 font-bold leading-snug flex-1" data-id="element-229">
                Qué comprar, qué evitar y cómo empezar sin gastar de más.
              </p>
              <div className="flex justify-between items-center mt-2 pt-2 border-t border-emerald-500/30" data-id="element-230">
                <span className="text-gray-500 text-[9px] line-through font-bold" data-id="element-231">
                  Valor $8.500
                </span>
                <span className="bg-[#16a34a] text-black text-[9px] font-black px-2 py-0.5 rounded uppercase" data-id="element-232">
                  GRATIS
                </span>
              </div>
            </div>
            <div className="bg-[#0d1530]/90 backdrop-blur-sm rounded-xl border-2 border-emerald-500/40 p-3 flex flex-col shadow-[0_0_15px_rgba(22,163,74,0.2)]" data-id="element-233">
              <h3 className="text-xs md:text-sm font-black text-[#f59e0b] mb-1.5 uppercase" data-id="element-234">
                🔓 Método Ganzúa PRO
              </h3>
              <p className="text-[10px] md:text-xs text-gray-300 font-bold leading-snug flex-1" data-id="element-235">
                Cómo abrir cerraduras paso a paso como un profesional.
              </p>
              <div className="flex justify-between items-center mt-2 pt-2 border-t border-emerald-500/30" data-id="element-236">
                <span className="text-gray-500 text-[9px] line-through font-bold" data-id="element-237">
                  Valor $8.500
                </span>
                <span className="bg-[#16a34a] text-black text-[9px] font-black px-2 py-0.5 rounded uppercase" data-id="element-238">
                  GRATIS
                </span>
              </div>
            </div>
            <div className="bg-[#0d1530]/90 backdrop-blur-sm rounded-xl border-2 border-emerald-500/40 p-3 flex flex-col shadow-[0_0_15px_rgba(22,163,74,0.2)]" data-id="element-239">
              <h3 className="text-xs md:text-sm font-black text-[#f59e0b] mb-1.5 uppercase" data-id="element-240">
                📖 Biblia del Cerrajero
              </h3>
              <p className="text-[10px] md:text-xs text-gray-300 font-bold leading-snug flex-1" data-id="element-241">
                Todo lo que necesitás saber para trabajar de verdad.
              </p>
              <div className="flex justify-between items-center mt-2 pt-2 border-t border-emerald-500/30" data-id="element-242">
                <span className="text-gray-500 text-[9px] line-through font-bold" data-id="element-243">
                  Valor $9.000
                </span>
                <span className="bg-[#16a34a] text-black text-[9px] font-black px-2 py-0.5 rounded uppercase" data-id="element-244">
                  GRATIS
                </span>
              </div>
            </div>
          </div>

          <div className="max-w-xs mx-auto bg-black/40 border-2 border-emerald-500/50 rounded-xl p-3 text-center shadow-[0_0_20px_rgba(22,163,74,0.2)]" data-id="element-245">
            <p className="text-gray-400 text-[9px] md:text-[10px] font-black uppercase tracking-widest mb-0.5" data-id="element-246">
              Valor total de los bonus:
            </p>
            <p className="text-white text-lg font-black line-through decoration-red-500 decoration-4 mb-0.5" data-id="element-247">
              $26.000
            </p>
            <p className="text-gray-400 text-[9px] md:text-[10px] font-black uppercase tracking-widest mb-0.5" data-id="element-248">
              Hoy te los llevás por:
            </p>
            <p className="text-[#16a34a] text-3xl md:text-4xl font-black mb-1 drop-shadow-[0_0_10px_rgba(22,163,74,0.4)]" data-id="element-249">
              $0
            </p>
            <p className="text-[#4ade80] font-black text-[9px] md:text-[10px] uppercase tracking-widest" data-id="element-250">
              ✨ INCLUIDOS GRATIS ✨
            </p>
          </div>
        </div>
      </section>

      {/* 12. URGENCY SECTION */}
      <section className="py-4 px-4 bg-[#0a0e27]" data-id="element-251">
        <div className="max-w-xl mx-auto text-center" data-id="element-252">
          <h2 className="text-sm md:text-base font-black text-white mb-2 uppercase tracking-wider" data-id="element-253">
            El precio de lanzamiento termina en
          </h2>
          <div className="flex items-center justify-center gap-2 mb-3" data-id="element-254">
            <div className="flex flex-col items-center" data-id="element-255">
              <div className="bg-red-700 border-2 border-red-400 rounded-lg w-12 h-12 flex items-center justify-center shadow-[0_0_15px_rgba(220,38,38,0.5)]" data-id="element-256">
                <span className="text-white text-2xl font-black" data-id="element-257">
                  {String(urgencyTime.hours).padStart(2, '0')}
                </span>
              </div>
              <span className="text-gray-400 text-[8px] font-black uppercase mt-1" data-id="element-258">
                Horas
              </span>
            </div>
            <span className="text-red-500 text-2xl font-black -mt-4" data-id="element-259">:</span>
            <div className="flex flex-col items-center" data-id="element-260">
              <div className="bg-red-700 border-2 border-red-400 rounded-lg w-12 h-12 flex items-center justify-center shadow-[0_0_15px_rgba(220,38,38,0.5)]" data-id="element-261">
                <span className="text-white text-2xl font-black" data-id="element-262">
                  {String(urgencyTime.minutes).padStart(2, '0')}
                </span>
              </div>
              <span className="text-gray-400 text-[8px] font-black uppercase mt-1" data-id="element-263">
                Minutos
              </span>
            </div>
            <span className="text-red-500 text-2xl font-black -mt-4" data-id="element-264">:</span>
            <div className="flex flex-col items-center" data-id="element-265">
              <div className="bg-red-700 border-2 border-red-400 rounded-lg w-12 h-12 flex items-center justify-center shadow-[0_0_15px_rgba(220,38,38,0.5)]" data-id="element-266">
                <span className="text-white text-2xl font-black" data-id="element-267">
                  {String(urgencyTime.seconds).padStart(2, '0')}
                </span>
              </div>
              <span className="text-gray-400 text-[8px] font-black uppercase mt-1" data-id="element-268">
                Segundos
              </span>
            </div>
          </div>
          <div className="flex justify-center gap-1 mb-3 flex-wrap" data-id="element-269">
            <span className="bg-red-900/50 border border-red-500/50 text-red-200 text-[9px] font-black px-2 py-0.5 rounded uppercase tracking-wider" data-id="element-270">
              🔥 Últimas unidades
            </span>
            <span className="bg-red-900/50 border border-red-500/50 text-red-200 text-[9px] font-black px-2 py-0.5 rounded uppercase tracking-wider" data-id="element-271">
              📢 Oferta Lanzamiento
            </span>
            <span className="bg-red-900/50 border border-red-500/50 text-red-200 text-[9px] font-black px-2 py-0.5 rounded uppercase tracking-wider" data-id="element-272">
              📈 Precio sube al terminar
            </span>
          </div>
          <div className="w-full h-2.5 bg-black rounded-full overflow-hidden border border-emerald-500/30" data-id="element-273">
            <div className="h-full bg-gradient-to-r from-red-600 to-red-400 w-[78%] shadow-[0_0_10px_rgba(239,68,68,0.8)]" data-id="element-274"></div>
          </div>
          <p className="text-red-400 text-[9px] font-black mt-1 uppercase tracking-widest text-right" data-id="element-275">
            78% de cupos ocupados
          </p>
        </div>
      </section>

      {/* 13. PRICING SECTION */}
      <section id="pricing" className="py-5 px-4 bg-[#0c1333]" data-id="element-276">
        <div className="max-w-3xl mx-auto" data-id="element-277">
          <h2 className="text-2xl md:text-3xl font-black text-white text-center mb-4 uppercase drop-shadow-md" data-id="element-278">
            Elegí tu Pack
          </h2>
          <PricingGrid selectedPack={selectedPack} setSelectedPack={setSelectedPack} packLinks={packLinks} data-id="element-279" />
        </div>
      </section>

      {/* 20. HOW IT WORKS */}
      <section className="py-4 px-4 bg-[#0f172a]" data-id="element-280">
        <div className="max-w-2xl mx-auto text-center" data-id="element-281">
          <h2 className="text-sm md:text-base font-black text-white mb-3 uppercase drop-shadow-md" data-id="element-282">
            🔽 ¿CÓMO RECIBÍS EL MATERIAL?
          </h2>
          <div className="grid grid-cols-3 gap-2" data-id="element-283">
            <div data-id="element-284">
              <div className="w-8 h-8 bg-[#16a34a] rounded-full flex items-center justify-center text-sm font-black text-black mx-auto mb-1 shadow-[0_0_15px_rgba(22,163,74,0.4)]" data-id="element-285">
                1
              </div>
              <h3 className="text-[10px] md:text-[11px] font-black text-white mb-0.5 uppercase" data-id="element-286">
                Comprás
              </h3>
              <p className="text-gray-400 text-[9px] font-bold" data-id="element-287">
                Ingresás tu correo.
              </p>
            </div>
            <div data-id="element-288">
              <div className="w-8 h-8 bg-[#16a34a] rounded-full flex items-center justify-center text-sm font-black text-black mx-auto mb-1 shadow-[0_0_15px_rgba(22,163,74,0.4)]" data-id="element-289">
                2
              </div>
              <h3 className="text-[10px] md:text-[11px] font-black text-white mb-0.5 uppercase" data-id="element-290">
                Pagás
              </h3>
              <p className="text-gray-400 text-[9px] font-bold" data-id="element-291">Pago seguro.</p>
            </div>
            <div data-id="element-292">
              <div className="w-8 h-8 bg-[#16a34a] rounded-full flex items-center justify-center text-sm font-black text-black mx-auto mb-1 shadow-[0_0_15px_rgba(22,163,74,0.4)]" data-id="element-293">
                3
              </div>
              <h3 className="text-[10px] md:text-[11px] font-black text-white mb-0.5 uppercase" data-id="element-294">
                Descargás
              </h3>
              <p className="text-gray-400 text-[9px] font-bold" data-id="element-295">
                Recibís el link.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 21. GUARANTEE */}
      <section className="py-4 px-4 bg-[#111827] border-t border-emerald-500/20 text-center" data-id="element-296">
        <ShieldCheckIcon className="w-12 h-12 text-[#16a34a] mx-auto mb-2 drop-shadow-[0_0_15px_rgba(22,163,74,0.6)]" data-id="element-297" />
        <h2 className="text-lg md:text-xl font-black text-white mb-1 uppercase" data-id="element-298">
          GARANTÍA DE SATISFACCIÓN TOTAL
        </h2>
        <p className="text-xs text-gray-400 font-bold max-w-md mx-auto" data-id="element-299">
          Probalo 7 días. Si no cumple tus expectativas, te devolvemos el 100%.
          Sin preguntas.
        </p>
      </section>

      {/* 14. TESTIMONIALS */}
      <section className="py-5 px-4 bg-[#0f172a]" data-id="element-300">
        <div className="max-w-4xl mx-auto" data-id="element-301">
          <h2 className="text-xl md:text-2xl font-black text-center text-white mb-4 uppercase drop-shadow-md" data-id="element-302">
            LO QUE DICEN NUESTROS{' '}
            <span className="text-[#16a34a]" data-id="element-303">ALUMNOS</span>
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3" data-id="element-304">
            <div className="bg-[#0d1530]/90 backdrop-blur-sm p-4 rounded-xl border-2 border-emerald-500/30 shadow-[0_0_15px_rgba(22,163,74,0.15)]" data-id="element-305">
              <div className="flex gap-0.5 text-yellow-400 mb-2" data-id="element-306">
                <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-307" />
                <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-308" />
                <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-309" />
                <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-310" />
                <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-311" />
              </div>
              <p className="text-gray-300 text-[11px] md:text-xs mb-2 italic font-bold leading-snug" data-id="element-312">
                "Siempre quise aprender un oficio que me diera libertad. Con
                este pack aprendí a abrir cerraduras en menos de dos semanas. Ya
                hice mis primeros trabajos y recuperé la inversión con el primer
                llamado. Lo recomiendo al 100%."
              </p>
              <div className="font-black text-white text-[10px] uppercase tracking-wider" data-id="element-313">
                Carlos M., 34 años –{' '}
                <span className="text-[#4ade80]" data-id="element-314">Buenos Aires</span>
              </div>
            </div>
            <div className="bg-[#0d1530]/90 backdrop-blur-sm p-4 rounded-xl border-2 border-emerald-500/30 shadow-[0_0_15px_rgba(22,163,74,0.15)]" data-id="element-315">
              <div className="flex gap-0.5 text-yellow-400 mb-2" data-id="element-316">
                <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-317" />
                <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-318" />
                <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-319" />
                <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-320" />
                <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-321" />
              </div>
              <p className="text-gray-300 text-[11px] md:text-xs mb-2 italic font-bold leading-snug" data-id="element-322">
                "Estaba sin trabajo y necesitaba algo urgente. Empecé a estudiar
                el material y en pocos días ya entendía cómo funcionaban las
                cerraduras. Hoy hago 3 o 4 trabajos por semana y genero más que
                en mi empleo anterior."
              </p>
              <div className="font-black text-white text-[10px] uppercase tracking-wider" data-id="element-323">
                Roberto G., 41 años –{' '}
                <span className="text-[#4ade80]" data-id="element-324">Córdoba</span>
              </div>
            </div>
            <div className="bg-[#0d1530]/90 backdrop-blur-sm p-4 rounded-xl border-2 border-emerald-500/30 shadow-[0_0_15px_rgba(22,163,74,0.15)]" data-id="element-325">
              <div className="flex gap-0.5 text-yellow-400 mb-2" data-id="element-326">
                <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-327" />
                <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-328" />
                <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-329" />
                <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-330" />
                <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-331" />
              </div>
              <p className="text-gray-300 text-[11px] md:text-xs mb-2 italic font-bold leading-snug" data-id="element-332">
                "No tenía idea de cerrajería. Los videos son muy claros y los
                manuales están bien explicados. En un mes ya estaba haciendo
                aperturas y cambios de cerraduras. La mejor inversión que hice."
              </p>
              <div className="font-black text-white text-[10px] uppercase tracking-wider" data-id="element-333">
                Fernando L., 28 años –{' '}
                <span className="text-[#4ade80]" data-id="element-334">Rosario</span>
              </div>
            </div>
            <div className="bg-[#0d1530]/90 backdrop-blur-sm p-4 rounded-xl border-2 border-emerald-500/30 shadow-[0_0_15px_rgba(22,163,74,0.15)]" data-id="element-335">
              <div className="flex gap-0.5 text-yellow-400 mb-2" data-id="element-336">
                <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-337" />
                <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-338" />
                <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-339" />
                <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-340" />
                <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-341" />
              </div>
              <p className="text-gray-300 text-[11px] md:text-xs mb-2 italic font-bold leading-snug" data-id="element-342">
                "Lo que más me gustó es que es todo práctico, sin vueltas.
                Aprendés las técnicas reales que se usan en el trabajo. El bonus
                del maletín me ayudó a saber exactamente qué herramientas
                comprar sin gastar de más."
              </p>
              <div className="font-black text-white text-[10px] uppercase tracking-wider" data-id="element-343">
                Miguel T., 38 años –{' '}
                <span className="text-[#4ade80]" data-id="element-344">Mendoza</span>
              </div>
            </div>
            <div className="bg-[#0d1530]/90 backdrop-blur-sm p-4 rounded-xl border-2 border-emerald-500/30 shadow-[0_0_15px_rgba(22,163,74,0.15)] md:col-span-2 lg:col-span-1" data-id="element-345">
              <div className="flex gap-0.5 text-yellow-400 mb-2" data-id="element-346">
                <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-347" />
                <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-348" />
                <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-349" />
                <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-350" />
                <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-351" />
              </div>
              <p className="text-gray-300 text-[11px] md:text-xs mb-2 italic font-bold leading-snug" data-id="element-352">
                "Tengo 45 años y pensé que era tarde para aprender algo nuevo.
                Este pack me demostró lo contrario. Hoy tengo clientes fijos y
                gano bien. Si yo pude, cualquiera puede."
              </p>
              <div className="font-black text-white text-[10px] uppercase tracking-wider" data-id="element-353">
                Alejandro R., 45 años –{' '}
                <span className="text-[#4ade80]" data-id="element-354">Tucumán</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 16. FAQ */}
      <section className="py-5 px-4 bg-[#0a0e27]" data-id="element-355">
        <div className="max-w-2xl mx-auto" data-id="element-356">
          <h2 className="text-xl md:text-2xl font-black text-center text-white mb-4 uppercase drop-shadow-md" data-id="element-357">
            PREGUNTAS <span className="text-[#16a34a]" data-id="element-358">FRECUENTES</span>
          </h2>
          <div className="space-y-1.5" data-id="element-359">
            {[{
            q: '¿En qué formato recibo el material?',
            a: 'Todo viene en PDF + videos, listo para ver desde cualquier dispositivo.'
          }, {
            q: '¿Necesito experiencia previa?',
            a: 'No, el sistema está diseñado para empezar desde cero, sin conocimientos previos.'
          }, {
            q: '¿Cuánto tarda en llegar después de pagar?',
            a: 'El acceso es inmediato. Apenas completás el pago, recibís el link de descarga en tu correo.'
          }, {
            q: '¿Puedo verlo desde el celular?',
            a: 'Sí, todo el material es compatible con celular, tablet y computadora.'
          }, {
            q: '¿Qué pasa si no me sirve?',
            a: 'Tenés 7 días de garantía total. Si no cumple tus expectativas, te devolvemos el 100%.'
          }, {
            q: '¿Necesito herramientas especiales para empezar?',
            a: 'El bonus del Maletín Inteligente te explica exactamente qué comprar y dónde, sin gastar de más.'
          }, {
            q: '¿En cuánto tiempo puedo empezar a trabajar?',
            a: 'Depende de tu dedicación, pero en 2 a 4 semanas ya podés hacer tus primeros trabajos.'
          }, {
            q: '¿Qué diferencia hay entre el pack de $19.990 y el de $29.990?',
            a: 'El de $29.990 incluye el módulo completo de cerrajería automotor: clonación de llaves, programación, transponder y sistemas electrónicos. Son trabajos mejor pagos.'
          }, {
            q: 'No tengo tarjeta de crédito, ¿puedo pagar de otra forma?',
            a: 'Sí, aceptamos Mercado Pago, transferencia, débito y crédito.'
          }, {
            q: '¿El material se actualiza?',
            a: 'Sí, tenés acceso de por vida y recibís actualizaciones sin costo adicional.'
          }].map((faq, i) => <details key={i} className="group bg-[#0d1530]/90 backdrop-blur-sm rounded-lg border-2 border-emerald-800/50 open:border-emerald-500/60 open:shadow-[0_0_15px_rgba(22,163,74,0.2)] transition-all duration-200" data-id="element-360">
                <summary className="flex items-center justify-between cursor-pointer p-3 text-xs md:text-sm font-black text-white list-none uppercase" data-id="element-361">
                  {faq.q}
                  <ChevronDownIcon className="w-4 h-4 text-[#16a34a] group-open:rotate-180 transition-transform" data-id="element-362" />
                </summary>
                <div className="px-3 pb-3 text-[10px] md:text-xs text-gray-300 font-bold leading-snug border-t border-emerald-500/20 pt-2" data-id="element-363">
                  {faq.a}
                </div>
              </details>)}
          </div>
        </div>
      </section>

      {/* 15. BOTTOM PRICING */}
      <section className="py-5 px-4 bg-[#0c1333]" data-id="element-364">
        <div className="max-w-3xl mx-auto" data-id="element-365">
          <h2 className="text-2xl md:text-3xl font-black text-white text-center mb-4 uppercase drop-shadow-md" data-id="element-366">
            Elegí tu Pack
          </h2>
          <PricingGrid selectedPack={selectedPack} setSelectedPack={setSelectedPack} packLinks={packLinks} data-id="element-367" />
        </div>
      </section>

      {/* 19. FOOTER */}
      <footer className="bg-[#050714] text-gray-600 py-4 px-4 text-center text-[9px] md:text-[10px] font-black uppercase tracking-widest border-t border-gray-800" data-id="element-368">
        <p className="mb-2" data-id="element-369">© 2026 Mega Pack Maestro Cerrajero™</p>
        <div className="flex justify-center gap-4" data-id="element-370">
          <span className="hover:text-gray-400 cursor-pointer transition-colors" data-id="element-371">
            Términos
          </span>
          <span className="hover:text-gray-400 cursor-pointer transition-colors" data-id="element-372">
            Privacidad
          </span>
          <span className="hover:text-gray-400 cursor-pointer transition-colors" data-id="element-373">
            Soporte
          </span>
        </div>
      </footer>
    </div>;
}